import { render, staticRenderFns } from "./WarehouseTabOffersInvoices.vue?vue&type=template&id=e670309e&scoped=true"
import script from "./WarehouseTabOffersInvoices.vue?vue&type=script&lang=js"
export * from "./WarehouseTabOffersInvoices.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabOffersInvoices.vue?vue&type=style&index=0&id=e670309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e670309e",
  null
  
)

export default component.exports